module.exports = __webpack_public_path__ + "static/img/bg1.8a83fb10.jpg";